import { jsx as _jsx } from "react/jsx-runtime";
import Dropdown from '@hellodarwin/core/lib/components/common/dropdown';
import { useMemo } from 'react';
import NavigationMenuLabel from '../../../navigation/menu-item/menu-item-label';
import useHandleLinkClick from '../../../navigation/utils/use-handle-link-click';
import { UserMenuDropdownStyled } from './styles';
import UserMenuButton from './user-menu-button';
const DesktopUserMenu = ({ user, links, notifs }) => {
    const handleLinkClick = useHandleLinkClick({ selectedKeys: [] });
    const dropdownItems = useMemo(() => links.map((link) => {
        const isCustomAction = !!link.onClick;
        return {
            key: link.pathname,
            label: (_jsx(NavigationMenuLabel, Object.assign({ handleLinkClick: isCustomAction ? undefined : handleLinkClick }, link, { pathname: isCustomAction ? '' : link.pathname }))),
            onClick: link.onClick,
        };
    }), [links, handleLinkClick]);
    return (_jsx("div", { style: { position: 'relative' }, children: _jsx(Dropdown, { items: dropdownItems, placement: "bottomRight", trigger: ['click'], ctaRender: () => (_jsx(UserMenuButton, { user: user, withArrow: true, notifs: notifs, isOnNav: true })), styles: {
                container: {
                    padding: 0,
                },
            }, popupRender: (origin) => (_jsx(UserMenuDropdownStyled, { children: origin })) }) }));
};
export default DesktopUserMenu;
